var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "v-stepper" },
    [
      _c(
        _vm.rootComponent,
        { tag: "component" },
        _vm._l(_vm.stepsArr, function(step, $index) {
          return _c("v-step", {
            key: $index,
            attrs: {
              name: _vm.id,
              debug: _vm.debug,
              index: $index,
              visited: step.visited,
              disabled: step.disabled,
              "with-divider": _vm.withDivider,
              active: step.index === _vm.toIndex(_vm.value)
            },
            on: { change: _vm.handleChange },
            scopedSlots: _vm._u(
              [
                {
                  key: "index",
                  fn: function(api) {
                    return [
                      _vm._t(
                        "step-" + api.displayIndex + "-index",
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(api.displayIndex) +
                              "\n        "
                          )
                        ],
                        null,
                        api
                      )
                    ]
                  }
                },
                {
                  key: "default",
                  fn: function(api) {
                    return [_vm._t("step-" + api.displayIndex, null, null, api)]
                  }
                }
              ],
              null,
              true
            )
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }